<template>
  <v-dialog name="asd" v-model="modalComputed" persistent  max-width="780" scrollable v-if="pdvComputed !== undefined">
    <v-card>

      <v-toolbar flat color="accent">
        <v-btn icon @click="modalComputed = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>M&oacute;dulos CF-e - Filial {{pdvComputed.cc_fil}}, PDV {{pdvComputed.cc_pdv}}</v-toolbar-title>
      </v-toolbar>

      <v-card-text class="ma-0 pa-0">
        <v-container>
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">

              <div v-if="itens.length === 0">
                <v-alert text type="info" color="primary">N&atilde;o h&aacute; m&oacute;dulos para este ponto de venda</v-alert>
              </div>

              <v-simple-table class="mb-2" v-else>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th width="30">Número de Série</th>
                      <th>C&oacute;d. Ativa&ccedil;&atilde;o</th>
                      <th>Assinatura AC</th>
                      <th width="120"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in itens" :key="item.id_reg">
                      <td>{{ item.cc_serie }}</td>
                      <td>{{ item.cc_cod_ativacao }}</td>
                      <td style="overflow: hidden;max-width: 400px;word-wrap: break-word;">{{ item.tx_signac }}</td>
                      <td>
                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                              <v-btn depressed small fab class="mr-1" :color="item.bl_ativo ? `primary` : ``" v-on="on" @click="ativar(item)">
                                <v-icon>mdi-check-bold</v-icon>
                              </v-btn>
                          </template>
                          <span>Ativar/Desativar</span>
                        </v-tooltip>
                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                              <v-btn depressed small fab class="mr-1" color="primary" v-on="on" @click="deletar(item)">
                                <v-icon>mdi-delete</v-icon>
                              </v-btn>
                          </template>
                          <span>Deletar</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-card outlined>
                <v-card-text>
                  <v-form ref="form" @submit="inserir()" v-model="valid" :lazy-validation="lazy" v-on:submit.prevent>
                    <v-container>
                      <v-row>
                          <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <v-text-field v-model="mfe.cc_serie" label="Número de série" :rules="validacao.cc_serie"></v-text-field>
                          </v-col>
                          <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <v-text-field v-model="mfe.cc_cod_ativacao" label="Cód. Ativação" :rules="validacao.cc_cod_ativacao"></v-text-field>
                          </v-col>
                          <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <v-text-field v-model="mfe.tx_signac" label="Assinatura AC" :rules="validacao.tx_signac"></v-text-field>    
                          </v-col>
                      </v-row>
                    </v-container>
                    <v-btn depressed outlined  type="submit" color="primary">INSERIR</v-btn>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { moeda } from '../../utils.js'
export default {

  name: 'ModuloCFE',

  data() {
    return {

      valid: true,
      lazy:true,
      itens:[],

      mfe: {
        cc_fil: undefined,
        cc_pdv: undefined,
        cc_serie: undefined,
        cc_cod_ativacao: undefined,
        tx_signac: undefined,
        bl_ativo: false
      },

      validacao: {
        cc_fil: [],
        cc_pdv: [],
        cc_serie: [],
        cc_cod_ativacao: [],
        tx_signac: [],
        bl_ativo: []
      },

      mfeTemp: undefined,
      modalTemp: undefined
    }
  },

  props: {

    pdv: {
      required: true
    },

    modal: {
      required: true,
      type: Boolean
    },

  },

  methods: {

    listar() {
      this.itens = []
      if(this.pdvComputed !== undefined) {
        this.$store.dispatch('pesquisaMFE', {size:9999, cc_fil: this.pdvComputed.cc_fil, cc_pdv: this.pdvComputed.cc_pdv}).then(resp => {
           resp.data.content.forEach(el => {
             this.itens.push(el)
           });
         }).catch()
      }
    },

    inserir() {
      if (this.$refs.form.validate()) {
        this.mfe.cc_fil = this.pdvComputed.cc_fil
        this.mfe.cc_pdv = this.pdvComputed.cc_pdv
        this.$store.dispatch('salvarMFE', this.mfe).then(() => {
          this.listar()
          this.resetarFormulario()
        }).catch()
      }
    },

    deletar(item) {
      this.$store.dispatch('deletarMFE', item.id_reg).then(() => {
        this.listar()
      }).catch()
    },

    ativar(item) {
      this.mfe.id_reg = item.id_reg
      this.mfe.cc_fil = item.cc_fil
      this.mfe.cc_pdv = item.cc_pdv
      this.mfe.cc_serie = item.cc_serie
      this.mfe.cc_cod_ativacao = item.cc_cod_ativacao
      this.mfe.tx_signac = item.tx_signac
      this.mfe.bl_ativo = !item.bl_ativo
      this.$store.dispatch('salvarMFE', this.mfe).then(() => {
        this.listar()
        this.resetarFormulario()
        this.mfe.id_reg = null
      }).catch()
    },

    resetarFormulario(){
      this.$refs.form.reset()
    },

    moeda(valor){
      return moeda(valor)
    }
  },

  computed: {
    modalComputed :  {
      get: function() { 
        return this.modalTemp
      },
      set: function(value) {
        this.modalTemp = value
      }
    },
    pdvComputed: {
      get: function() { 
        return this.pdvTemp
      },
      set: function(value) {
        this.pdvTemp = value
      }
    }
  },

  mounted: function() {
    this.listar()
  },

  created: function() {

    this.modalComputed = this.modal
    this.pdvComputed = this.pdv
    this.$emit('a')

  }

}
</script>